import { CLEAR_USER_NAME } from "./index";

export const clearUserName = () => {
    return { type: CLEAR_USER_NAME }
};


export const fetchNewValue = () => ({
    type: "CLEAR_NAME"
})


export const getUser = user => ({
    type: 'GET_USER',
    payload: user,
});



export const fetchNewData = (state) => {
    return function (dispatch) {
        dispatch({
            type: 'UPDATE_NAME',
            payload: state
        });
    }
}

export const signInAction = (payload) => {
    return {
        type: "UPDATE_NAME",
        payload
    }
}

export const clearUser = (payload) => {
    return {
        type: "CLEAR_NAME",
        payload
    }
}

export const signOut = (payload) => {
    return {
        type: "SIGN_OUT",
        payload
    }
}

export const updateStatus = (payload) => {
    return {
        type: "UPDATE_STATE",
        payload
    }
}